import { SVGProps } from 'react'

export function TeamIcon({ src, alt }: { src: string; alt: string }) {
	return (
		<div className='relative h-8 w-7 shrink-0'>
			<svg className='absolute inset-0' width='26' height='30' viewBox='0 0 26 30' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path
					d='M11.251 1.58594C12.3333 0.961594 13.6667 0.961593 14.749 1.58594L23.749 6.77832C24.8325 7.40339 25.5 8.55972 25.5 9.81055V20.1895C25.5 21.4403 24.8325 22.5966 23.749 23.2217L14.749 28.4141C13.6667 29.0384 12.3333 29.0384 11.251 28.4141L2.25098 23.2217C1.16752 22.5966 0.5 21.4403 0.5 20.1895V9.81055C0.5 8.55972 1.16753 7.40339 2.25098 6.77832L11.251 1.58594Z'
					className='fill-card stroke-border'
					strokeWidth='1'
				/>
			</svg>
			<img src={src} alt={alt} className='absolute left-[5px] top-[7px] h-[18px] w-[18px] object-cover' />
		</div>
	)
}

export function ClockIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='16' height='16' viewBox='0 0 16 16' fill='none' className='shrink-0 text-muted-foreground' {...props}>
			<path
				d='M7.9987 1.33331C4.32536 1.33331 1.33203 4.32665 1.33203 7.99998C1.33203 11.6733 4.32536 14.6666 7.9987 14.6666C11.672 14.6666 14.6654 11.6733 14.6654 7.99998C14.6654 4.32665 11.672 1.33331 7.9987 1.33331ZM10.8987 10.38C10.8054 10.54 10.6387 10.6266 10.4654 10.6266C10.3787 10.6266 10.292 10.6066 10.212 10.5533L8.14536 9.31998C7.63203 9.01331 7.25203 8.33998 7.25203 7.74665V5.01331C7.25203 4.73998 7.4787 4.51331 7.75203 4.51331C8.02536 4.51331 8.25203 4.73998 8.25203 5.01331V7.74665C8.25203 7.98665 8.45203 8.33998 8.6587 8.45998L10.7254 9.69331C10.9654 9.83331 11.0454 10.14 10.8987 10.38Z'
				fill='currentColor'
			/>
		</svg>
	)
}

export function ProfileTwoUserIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg width='28' height='28' viewBox='0 0 28 28' fill='none' {...props}>
			<path
				d='M10.4987 2.33331C7.44203 2.33331 4.95703 4.81831 4.95703 7.87498C4.95703 10.8733 7.30203 13.3 10.3587 13.405C10.452 13.3933 10.5454 13.3933 10.6154 13.405C10.6387 13.405 10.6504 13.405 10.6737 13.405C10.6854 13.405 10.6854 13.405 10.697 13.405C13.6837 13.3 16.0287 10.8733 16.0404 7.87498C16.0404 4.81831 13.5554 2.33331 10.4987 2.33331Z'
				fill='currentColor'
			/>
			<path
				d='M16.4252 16.5084C13.1702 14.3384 7.86182 14.3384 4.58349 16.5084C3.10182 17.5 2.28516 18.8417 2.28516 20.2767C2.28516 21.7117 3.10182 23.0417 4.57182 24.0217C6.20516 25.1184 8.35182 25.6667 10.4985 25.6667C12.6452 25.6667 14.7918 25.1184 16.4252 24.0217C17.8952 23.03 18.7118 21.7 18.7118 20.2534C18.7002 18.8184 17.8952 17.4884 16.4252 16.5084Z'
				fill='currentColor'
			/>
			<path
				d='M23.3209 8.56331C23.5076 10.8266 21.8976 12.81 19.6693 13.0783C19.6576 13.0783 19.6576 13.0783 19.6459 13.0783H19.6109C19.5409 13.0783 19.4709 13.0783 19.4126 13.1016C18.2809 13.16 17.2426 12.7983 16.4609 12.1333C17.6626 11.06 18.3509 9.44997 18.2109 7.69997C18.1293 6.75497 17.8026 5.89164 17.3126 5.15664C17.7559 4.93497 18.2693 4.79497 18.7943 4.74831C21.0809 4.54997 23.1226 6.25331 23.3209 8.56331Z'
				fill='currentColor'
			/>
			<path
				d='M25.6536 19.355C25.5603 20.4867 24.837 21.4667 23.6236 22.1317C22.457 22.7733 20.987 23.0767 19.5286 23.0417C20.3686 22.2833 20.8586 21.3383 20.952 20.335C21.0686 18.8883 20.3803 17.5 19.0036 16.3917C18.222 15.7733 17.312 15.2833 16.3203 14.9217C18.8986 14.175 22.142 14.6767 24.137 16.2867C25.2103 17.15 25.7586 18.235 25.6536 19.355Z'
				fill='currentColor'
			/>
		</svg>
	)
}
